import { Notifier } from '@airbrake/browser';

import { getEnv } from '@ctct/ctct-helpers';

import { AirbrakeFiltersService } from './AirbrakeFiltersService';

export class AirbrakeClient {
  private static instance: Notifier | null = null;

  // disable, because constructor should be private
  // eslint-disable-next-line no-useless-constructor, @typescript-eslint/no-empty-function
  private constructor() {}

  public static notify(error: unknown, info?: unknown, context?: Record<string, unknown>): void {
    const payload: {
      error: unknown;
      params: { info?: unknown };
      context?: Record<string, unknown>;
    } = { error, params: { info } };

    if (context) {
      payload.context = context;
    }

    this.getInstance().notify(payload);
  }

  private static getInstance(): Notifier {
    if (!this.instance) {
      this.instance = this.createAirbrakeClient();
    }

    return this.instance;
  }

  private static createAirbrakeClient(): Notifier {
    let creds = {
      projectId: 576218,
      projectKey: '02a4ec5095c56c96763b905cc85677f9',
    };

    const isSecure = window.location.href.includes('secure.');

    if (isSecure) {
      creds = {
        projectId: 627031,
        projectKey: 'af93915b6a8a0e6d980ceee1bc37ebf3',
      };
    }

    const client = new Notifier({
      ...creds,
      environment: {
        '.': 'prod',
        '.l1.': 'l1',
        '.s1.': 's1',
      }[getEnv()],
    });

    const airbrakeFiltersService = new AirbrakeFiltersService();

    client.addFilter((...args) => airbrakeFiltersService.filterVitestRunnerErrors(...args));
    client.addFilter((...args) => airbrakeFiltersService.filterLocalhost(...args));
    client.addFilter((...args) => airbrakeFiltersService.filterBrowserExtensionErrors(...args));
    client.addFilter((...args) => airbrakeFiltersService.filterDistUIErrors(...args));
    client.addFilter((...args) => airbrakeFiltersService.filterHttpErrors(...args));
    client.addFilter((...args) => airbrakeFiltersService.filterNetworkErrors(...args));
    client.addFilter((...args) => airbrakeFiltersService.filterSensitiveData(...args));

    return client;
  }
}
